import { Box, Typography, IconButton, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { IBannerProps } from "./interfaces/banner.interface";
import { bannerSizeConfig, bannerVariantConfig } from "./config/banner.config";

//The following code is not implemented yet, it will be implemented in the future.

// import {
//     FLOW_HUB_BUTTON_PRIMARY_CONFIG,
//     FLOW_HUB_BUTTON_SECONDARY_CONFIG,
//     FLOW_HUB_BUTTON_GHOST_CONFIG,
// } from "../../config";

// const actionSxMap = {
//     primary:   FLOW_HUB_BUTTON_PRIMARY_CONFIG,
//     secondary: FLOW_HUB_BUTTON_SECONDARY_CONFIG,
//     ghost:     FLOW_HUB_BUTTON_GHOST_CONFIG,
// } as const;

export const Banner = ({
    variant = "info",
    size = "md",
    title,
    description,
    icon,
    primaryAction,
    secondaryAction,
    dismissible,
    onDismiss,
    children,
    className,
}: IBannerProps) => {
    const { iconColor, borderColor, borderLeftColor, ...variantStyles } = bannerVariantConfig(variant);
    const { iconSize, gap, borderRadius, borderWidth, borderLeftWidth, ...sizeStyles } = bannerSizeConfig(size);

    return (
        <Box
            className={className}
            sx={{
                ...variantStyles,
                ...sizeStyles,
                display: "flex",
                flexDirection: "column",
                gap,
                borderRadius,
                border: `${borderWidth} solid ${borderColor}`,
                borderLeft: `${borderLeftWidth} solid ${borderLeftColor}`,
                position: "relative",
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center", gap, width: "100%" }}>
                {icon && (
                    <Box sx={{ color: iconColor, fontSize: iconSize, display: "flex" }}>
                        {icon}
                    </Box>
                )}
                {title && (
                    <Typography sx={{ fontWeight: 600, fontSize: "inherit", lineHeight: "inherit", flex: 1 }}>
                        {title}
                    </Typography>
                )}
                {dismissible && (
                    <IconButton size="small" onClick={onDismiss} sx={{ color: "inherit", ml: "auto", p: 0.5 }}>
                        <CloseIcon fontSize="inherit" />
                    </IconButton>
                )}
            </Box>

            {description && (
                <Typography sx={{ fontSize: "inherit", lineHeight: "inherit", opacity: 0.9 }}>
                    {description}
                </Typography>
            )}

            {children}

            {(primaryAction || secondaryAction) && (
                <Box sx={{ display: "flex", gap, mt: 0.5 }}>
                    {primaryAction && (
                        <Button
                            onClick={primaryAction.onClick}
                        // sx={actionSxMap[primaryAction.variant ?? "primary"]}
                        >
                            {primaryAction.label}
                        </Button>
                    )}
                    {secondaryAction && (
                        <Button
                            onClick={secondaryAction.onClick}
                        // sx={actionSxMap[secondaryAction.variant ?? "secondary"]}
                        >
                            {secondaryAction.label}
                        </Button>
                    )}
                </Box>
            )}
        </Box>
    );
};